(function() {
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.eventBus) return;

    eventBus.on('variant:change', ({ variant, sectionId }) => {
      if (!variant || !variant.id) return;

      const url = `${window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`;

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const temp = document.createElement('div');
          temp.innerHTML = html;

          const newMobile = temp.querySelector('#productMediaMobile');
          const currentMobile = document.querySelector('#productMediaMobile');

          if (newMobile && currentMobile) {
            currentMobile.replaceWith(newMobile);
          }
        })
        .catch(err => {
          console.error('Errore aggiornamento slider mobile:', err);
        });
    });
  });
})();
